var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "71EA38D4-55C4-469C-B81E-9788CAD78EDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_Dash",
    transform: "translate(-1161.000000, -114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(1145.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-shape",
    transform: "translate(20.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.102793,12.6 L15.1384191,12.6 C16.0067578,12.6 16.7106854,13.3039276 16.7106854,14.1722663 C16.7106854,14.6498952 16.4935716,15.1016276 16.1206061,15.4 L14.3697522,16.8006831 C13.34714,17.6187729 11.8940722,17.6187729 10.8714599,16.8006831 L9.12060608,15.4 C8.44254747,14.8575531 8.33261245,13.8681379 8.87505933,13.1900793 C9.17343175,12.8171138 9.62516414,12.6 10.102793,12.6 Z",
    id: "Rectangle",
    fill: "#BD65F0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#BD65F0",
    strokeWidth: 3,
    transform: "translate(12.600000, 12.600000) rotate(-315.000000) translate(-12.600000, -12.600000) ",
    x: 2.7,
    y: 2.7,
    width: 19.8,
    height: 19.8,
    rx: 5.6
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShape);
export default __webpack_public_path__ + "static/media/logo-shape.8afebc58ac8b50a3a8d457c1cd28f8de.svg";
export { ForwardRef as ReactComponent };